import axiosRef from "axios";

const axios = axiosRef.create({
  baseURL: process.env.REACT_APP_BASE_API_URL, // Centralized base URL
});

// Response interceptor to handle errors globally
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.error("Unauthorized error detected. Redirecting...");
      window.location.href = "/unauthorized"; // Redirect to the error page
    }
    return Promise.reject(error); // Forward the error for custom handling
  }
);

export const signIn = async (credentials, navigate) => {
  try {
    const response = await axios.post(process.env.REACT_APP_BASE_API_URL+'/auth/login', credentials);

    // Extract data and token from response
    const { data, token } = response.data;

    // Save token to localStorage
    localStorage.setItem('token', token);
    localStorage.setItem('userType', data.type);

    // Check user type and redirect accordingly
    if (data.type === 'user') {
      window.dispatchEvent(new Event("localstorage-update"));
      navigate('/client');
    } else if (data.type === 'admin') {
      window.dispatchEvent(new Event("localstorage-update"));
      navigate('/admin');
    }

    return response;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message || 'Sign-in failed');
    } else {
      throw new Error('Network error');
    }
  }
};

export async function ValidateSignIn (email, password) {
    const formData ={
        email,
        password
    }
    try {
        const response = await fetch(process.env.REACT_APP_BASE_API_URL+'/api/auth/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });
  
        const result = response;
        if (response.status == 200) {
          // Handle successful signup
          return result;
        } else {
          // Handle errors (e.g., validation errors)
          return result.error || {};
        }
      } catch (error) {
        console.error('Error:', error);
      }
      return;
}

export async function ValidateSignUP (state, navigate) {
    const nameParts = state.name.split(" ");
    const firstName = nameParts[0];
    const lastName = nameParts.slice(1).join(" "); 
   
    const formData = {
        first_name : firstName,
        last_name : lastName,
        email : state.email,
        password : state.password
    }
    
        try {
          const response = await axios.post(process.env.REACT_APP_BASE_API_URL+'/auth/register', formData);
    
          const result = response;

          const { data, token } = response.data;

          

          if (response.success == true) {
            // Handle successful signup
            
            return response;
          } else {
            // Handle errors (e.g., validation errors)
            return response;
          }
        } catch (error) {
          console.error('Error:', error);
        }
        return;
}


export const HandleLogout = async (token) => {
  try {
    const response = await axios.post(process.env.REACT_APP_BASE_API_URL+"/auth/logout", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // or response if you need the whole response
  } catch (error) {
    console.error("Error fetching devices:", error);
    throw error;
  }
};